let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f3D1v")).then(() => parcelRequire('lzquo'));